const state = {
    itemBalances: [],    
    loading: false
};

export default state;